<template lang="pug">
.note(:id="`note_${noteId}`")
  .meta
    .d-flex.justify-content-between
      .project-name {{ noteProjectName }}
      .d-flex.justify-content-between(v-if="ownActivity")
        a.clickable(@click="showEditNoteDialog") Edit
        a.clickable(@click="onDeleteNote") Delete
    .clearfix
    .recorded-at {{ $filters.formatDateTime(noteRecordedAt) }}
  p {{ noteDescription }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ActivitiesNote',
  props: {
    noteId: {
      type: Number,
      required: true,
    },
    noteProjectName: {
      type: String,
      required: true,
    },
    noteRecordedAt: {
      type: String,
      required: true,
    },
    noteDescription: {
      type: String,
      required: true,
    },
    ownActivity: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['queryUserId']),
  },
  methods: {
    ...mapActions(['deleteNote']),
    error() {
      this.$appMessage('Something went wrong. Please try again.');
    },
    onDeleteNote() {
      if (confirm('Delete this note?')) {
        const success = (response) => {
          if (response.success) {
            this.$appMessage('Note deleted');
          } else {
            this.$appMessage('Something went wrong. Please try again.');
          }
        };

        this.deleteNote({ noteId: this.noteId }).then(success, this.error);
      }
    },
    showEditNoteDialog() {
      AjaxDialog.run(`/notes/${this.noteId}/edit.dialog`);
      this.$emit('edit-dialog-opened');
    },
  },
};
</script>
